import { useReactiveVar } from '@apollo/client'
import {
  Hidden,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import ContractIcon from '@material-ui/icons/Assignment'
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded'
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded'
import LanguageIcon from '@material-ui/icons/Language'
import NightsStayRoundedIcon from '@material-ui/icons/NightsStayRounded'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import WbSunnyIcon from '@material-ui/icons/WbSunny'
import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import AdotelLogoDark from '../../assets/images/AdotelLogoDark.svg'
import AdotelLogoLight from '../../assets/images/AdotelLogoLight.svg'
import HomaLogo from '../../assets/images/Homa.png'
import ITTICLogo from '../../assets/images/ittic logo.png'
import { CartDetails, totalQuantityVar } from '../../cache/cart'
import { jobsListVar } from '../../cache/jobs'
import { darkMode } from '../../cache/preferences'
import { JobsTable } from '../../components/Jobs/JobsTable'
import NotificationBell from '../../components/NotificationBell'
import SessionLoginNotice from '../../components/SessionLoginNotice'
import SupportButton from '../../components/SupportButton'
import { logout } from '../../helpers/logout'
import {
  getNameFromStorage,
  getLanguagesAvailable,
  getEntityCode,
  getRoleFromStorage,
  getEntityId,
  getEntityName
} from '../../helpers/userData'
import {
  changeLang,
  getLangLabel,
  getTranslate,
  lang
} from '../../localization'
import { ROLE } from '../../staticRoleManagement/types'
import useStyles from './styles/index.styles'

interface TopMenuProps {
  open: boolean
  jobsModalIsOpen: boolean
  setjobsModalIsOpen: (val: boolean) => void
}
export const TopMenu: React.FC<TopMenuProps> = ({
  jobsModalIsOpen,
  setjobsModalIsOpen
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const wrapperRef = useRef<HTMLDivElement | null>(null)
  const [profileOpen, setProfileOpen] = useState<boolean>(false)
  const [shouldShake, setShouldShake] = useState<boolean>(false)
  const [jobsOpen, setJobsOpen] = useState<boolean>(false)
  const jobWrapperRef = useRef<HTMLDivElement | null>(null)
  const [langOpen, setLangOpen] = useState(false)
  const shoppingCartWrapperRef = useRef<HTMLDivElement | null>(null)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const jobs = useReactiveVar(jobsListVar)
  const darktheme = useReactiveVar(darkMode)
  const totalQuantity = useReactiveVar(totalQuantityVar)

  const CartDetailsJson = localStorage.getItem('cartDetails')
  const cartDetails: CartDetails = CartDetailsJson
    ? JSON.parse(CartDetailsJson)
    : {
        channelID: '',
        channelCode: '',
        channelName: '',
        propertyCode: '',
        currrncy: ''
      }

  const langWrapperRef = useRef<HTMLDivElement | null>(null)
  const changeTheme = () => {
    if (darkMode()) {
      darkMode(false)
    } else {
      darkMode(true)
    }
    localStorage.theme = localStorage.theme === 'dark' ? 'light' : 'dark'
  }

  // useEffect(() => {
  //   const handleInvalidToken = (e: any) => {
  //     if (e.key === 'loggedout') {
  //       localStorage.clear()
  //       sessionStorage.clear()
  //       Cookies.remove('credentials')
  //       window.location.href = `${window.location.origin}/login`
  //     }
  //   }

  //   window.addEventListener('storage', handleInvalidToken)

  //   return function cleanup() {
  //     window.removeEventListener('storage', handleInvalidToken)
  //   }
  // }, [logout])

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef?.current?.contains(event.target as Node) &&
        profileOpen
      ) {
        setTimeout(() => {
          setProfileOpen(false)
        }, 270)
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef, profileOpen])

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (
        jobWrapperRef.current &&
        !jobWrapperRef?.current?.contains(event.target as Node) &&
        jobsOpen
      ) {
        setTimeout(() => {
          setJobsOpen(false)
        }, 270)
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [jobWrapperRef, jobsOpen])

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (
        langWrapperRef.current &&
        !langWrapperRef?.current?.contains(event.target as Node) &&
        langOpen
      ) {
        setTimeout(() => {
          setLangOpen(false)
        }, 270)
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [langWrapperRef, langOpen])

  const ValidChannelRoles = [ROLE.CHANNEL, ROLE.CHANNEL_ADMIN]
  const isRoleChannel = ValidChannelRoles.includes(getRoleFromStorage())

  useEffect(() => {
    if (totalQuantity > 0) {
      setShouldShake(true)
      const timer = setTimeout(() => {
        setShouldShake(false)
      }, 500)
      return () => clearTimeout(timer)
    }
  }, [totalQuantity])

  return (
    <div className={classes.topMenu}>
      <div className={classes.leftTopMenu}>
        <div className={classes.profileImageContainer}>
          <img
            src={darktheme ? AdotelLogoDark : AdotelLogoLight}
            alt="profile"
            className={classes.profileImage}
          />
        </div>
        {getEntityCode() == '102' && (
          <div className={classes.itticImageContainer}>
            <img
              src={ITTICLogo}
              alt="ittic-logo"
              className={classes.profileImage}
            />
          </div>
        )}
        {getEntityCode() == '109' && (
          <div
            className={[
              classes.itticImageContainer,
              classes.homaImageContainer
            ].join(' ')}>
            <img
              src={HomaLogo}
              alt="homa-logo"
              className={classes.profileImage}
            />
          </div>
        )}
        <IconButton
          data-cy="headerMenuIcon"
          color="inherit"
          aria-label="open profile"
          onClick={() => setProfileOpen(!profileOpen)}
          edge="start"
          className={clsx(classes.iconButton, {
            [classes.profileOpened]: profileOpen,
            [classes.profileNotOpened]: !profileOpen
          })}>
          <KeyboardArrowDownRoundedIcon />
        </IconButton>
        <div
          className={clsx(classes.profileMenuContainer, {
            [classes.hide]: !profileOpen
          })}
          ref={wrapperRef}>
          <MenuList>
            <MenuItem>
              <ListItemText
                primary={getNameFromStorage()}
                className={classes.ListItemName}
              />
            </MenuItem>
            <MenuItem
              onClick={logout}
              button
              data-cy="logoutBtn"
              className={classes.ListItemLogout}>
              <ListItemIcon className={classes.ListItemIconLogout}>
                <ExitToAppRoundedIcon />
              </ListItemIcon>
              <ListItemText
                secondary={getTranslate('Log out')}
                className={classes.ListItemLogout}
              />
            </MenuItem>
          </MenuList>
        </div>
      </div>
      <div className={classes.rightTopMenu}>
        <SessionLoginNotice />
        <NotificationBell />
        <SupportButton />
        <Hidden smDown>
          <IconButton
            color="inherit"
            aria-label="open jobs"
            onClick={
              isSmallScreen
                ? () => setjobsModalIsOpen(!jobsModalIsOpen)
                : () => setJobsOpen(!jobsOpen)
            }
            edge="start"
            className={classes.iconButton}>
            <ContractIcon />
            {jobs.filter((item) => item.trackID).length ? (
              <span className={classes.jobCounter}>
                {jobs.filter((item) => item.trackID).length}
              </span>
            ) : null}
          </IconButton>
          <div
            className={clsx(classes.jobsstyle, {
              [classes.hide]: !jobsOpen
            })}
            ref={jobWrapperRef}>
            <JobsTable />
          </div>{' '}
        </Hidden>
        <IconButton
          color="inherit"
          aria-label="open language selector"
          onClick={() => setLangOpen(!langOpen)}
          edge="start"
          className={classes.iconButton}>
          <LanguageIcon />
          <div
            className={clsx(classes.langContainer, {
              [classes.hide]: !langOpen
            })}
            ref={langWrapperRef}>
            <MenuList>
              {/*
                Only languages the panel can actually switch to are listed. A code
                with no label (an unknown or not-yet-supported language) used to
                render as a blank, disabled row — which is indistinguishable from a
                broken menu, and was reported from stage as an empty white box.
                Codes arrive normalised from getLanguagesAvailable().
              */}
              {getLanguagesAvailable()
                .filter((l) => getLangLabel(l))
                .map((l) => (
                  <MenuItem
                    key={l}
                    button
                    disabled={l !== 'EN' && l !== 'FA'}
                    onClick={() => changeLang(l.toLowerCase())}>
                    <ListItemText
                      secondary={getLangLabel(l)}
                      className={[
                        classes.ListItemlang,
                        l !== 'EN' && classes.iranSans
                      ].join(' ')}
                    />
                  </MenuItem>
                ))}
            </MenuList>
          </div>
        </IconButton>
        <IconButton
          color="inherit"
          aria-label="change theme"
          onClick={changeTheme}
          edge="start"
          className={classes.iconButton}>
          {localStorage.theme === 'dark' ? (
            <WbSunnyIcon />
          ) : (
            <NightsStayRoundedIcon />
          )}
        </IconButton>
        <IconButton
          color="inherit"
          aria-label="open shoppingCart"
          onClick={() => {
            if (totalQuantity > 0) {
              history.push(
                `/${lang}/book/${cartDetails.channelID}/${cartDetails.channelCode}/${cartDetails.channelName}/bookstepper/cart`
              )
            } else if (isRoleChannel) {
              history.push(
                `/${lang}/book/${getEntityId()}/${getEntityCode()}/${getEntityName()}`
              )
            } else {
              history.push(`/${lang}/book/select-channel`)
            }
          }}
          edge="start"
          className={[
            classes.iconButton,
            shouldShake && classes.shoppingCartIcon
          ].join(' ')}>
          <ShoppingCartIcon />
          <span
            className={[
              Number(totalQuantity) > 0 ? classes.jobCounter : ''
            ].join(' ')}>
            {Number(totalQuantity) > 0 && Number(totalQuantity)}
          </span>
        </IconButton>

        <div
          className={[classes.tableContainer].join(' ')}
          ref={shoppingCartWrapperRef}></div>
      </div>
    </div>
  )
}

export default TopMenu
